// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "aiyuceng/css/" + chunkId + "." + {"95":"4cf1af3c","526":"af46d427","811":"73c26c86"}[chunkId] + ".css";
};